<!-- Start Home Page Section -->
<div class="ecb-web-home-page">
  <a href="https://www.iitcglobal.com/"></a>
  <a href="https://iitcglobal.net/"></a>
  <!-- Start Banner Section -->
  <section class="ecb-web-banner-section ">
    <div class="ecb-web-banner-overlay"></div>

    <div class="container ecb-web-banner-container">
      <div class="row align-items-center">

        <!-- Start Banner Content Section -->
        <div class="col-12 col-lg-7">
          <div class="ecb-web-banner-content">

            <h5 class="ecb-web-banner-small-title"> Australia's <span>Trusted</span> </h5>

            <h1>
              Training Partner
            </h1>

            <div class="ecb-web-voc-title-line"></div>

            <p class="ecb-web-banner-description">
              Nationally recognised training for Mining, Construction,
              Civil and High-Risk Industries.
            </p>

            <ul class="ecb-web-banner-feature-list">
              <li>
                <i class="bi bi-check-circle"></i>
                Registered Training Organisation (RTO No 41369)
              </li>

              <li>
                <i class="bi bi-check-circle"></i>
                Nationally Accredited Courses
              </li>

              <li>
                <i class="bi bi-check-circle"></i>
                Industry Experienced Trainers
              </li>

              <li>
                <i class="bi bi-check-circle"></i>
                Australia Wide
              </li>
            </ul>

            <div class="ecb-web-banner-button-group">
              <a href="#training-pathway" class="btn ecb-web-primary-button">
                Find a Course
                <i class="bi bi-arrow-right"></i>
              </a>

              <a href="/course-calendar" class="btn ecb-web-outline-button">
                View Course Calendar
                <i class="bi bi-calendar3"></i>
              </a>
            </div>

            <div class="ecb-web-banner-review">
              <span class="ecb-web-google-letter">G</span>
              <strong>4.9</strong>

              <span class="ecb-web-review-stars">
                <i class="bi bi-star-fill"></i>
                <i class="bi bi-star-fill"></i>
                <i class="bi bi-star-fill"></i>
                <i class="bi bi-star-fill"></i>
                <i class="bi bi-star-fill"></i>
              </span>

              <span>on Google with numerous customer reviews. </span>
            </div>

          </div>
        </div>
        <!-- End Banner Content Section -->

        <!-- Start Banner Worker Image Section -->
        <!-- <div class="col-lg-5 d-none d-lg-block">
          <div class="ecb-web-banner-worker-wrapper">
            <img src="../../../assets/images/ecb-hero-bg.webp" alt="ECB Training Worker"
              class="ecb-web-banner-worker-image">
          </div>
        </div> -->
        <!-- End Banner Worker Image Section -->

      </div>
    </div>
  </section>
  <!-- End Banner Section -->


  <!-- Start Training Pathway Heading Section -->
  <section id="training-pathway" class="ecb-web-pathway-heading-section">
    <div class="container">

      <div class="ecb-web-pathway-heading-card text-center">

        <div class="ecb-web-pathway-title-row">
          <span class="ecb-web-pathway-title-line"></span>

          <h2 class="ecb-web-pathway-main-title">
            Find Your Training Pathway
          </h2>

          <span class="ecb-web-pathway-title-line"></span>
        </div>

        <p class="ecb-web-pathway-subtitle">
          Choose the right option to get started
        </p>

      </div>

    </div>
  </section>
  <!-- End Training Pathway Heading Section -->




  <!-- Start Training Options Section -->
  <section class="ecb-web-training-options-section" id="training-section">

    <div class="container">

      <div class="row g-4">

        <!-- =====================================================
           Start Long Courses Card
      ====================================================== -->
        <div class="col-12 col-xl-6">

          <article class="ecb-web-training-category-card ecb-web-long-course-card h-100">

            <!-- Floating Icon -->
            <div class="ecb-web-training-category-icon ecb-web-long-course-icon">
              <i class="bi bi-mortarboard-fill"></i>
            </div>

            <!-- Start Qualifications Heading -->
            <div class="ecb-web-training-category-header text-center">

              <!-- Dynamic Title -->
              <h3>
                {{ homeCourseContent['QUALIFICATIONS']?.title ?? 'Qualifications' }}
              </h3>

              <!-- Dynamic Subtitle -->
              <h5>
                {{ homeCourseContent['QUALIFICATIONS']?.subTitle ?? 'Nationally Recognised Qualifications' }}
              </h5>

              <!-- Dynamic Description -->
              <p class="ecb-web-home-dynamic-description">
                {{ homeCourseContent['QUALIFICATIONS']?.description ?? 'Build your career with a full qualification.   Certificates I to Diploma level.' }}
              </p>

            </div>
            <!-- End Qualifications Heading -->
            <!-- Start State Selection -->
            <div class="ecb-states-select-wrapper">

                <label class="ecb-states-select-label">Location</label>


                <p-selectButton
    [options]="statesList"
    [ngModel]="selectedQualificationStateCode"
    (ngModelChange)="onQualificationStateChange($event)"
    optionLabel="siteName"
    optionValue="code"
    [multiple]="false"
    [allowEmpty]="false"
    styleClass="ecb-states-select-button">
  </p-selectButton>


            </div>
            <!-- End State Selection -->

            <!-- Start Qualification Search -->
            <div class="ecb-web-long-course-search">



              <div class="ecb-web-long-course-search-field">

                <label>All Courses</label>

                <p-dropdown [options]="longCourseOptions" [(ngModel)]="selectedLongCourseId" optionValue="courseId"
                  [filter]="true" filterBy="courseCode,courseName,qualificationType" [showClear]="true"
                  [virtualScroll]="true" [virtualScrollItemSize]="42" appendTo="body" placeholder="Select a course">

                  <ng-template pTemplate="selectedItem" let-item>
                    <span *ngIf="item">
                      {{ item.courseCode }} - {{ item.courseName }}
                    </span>
                  </ng-template>

                  <ng-template pTemplate="item" let-item>
                    <div class="ecb-web-course-option">
                      <strong>{{ item.courseCode }}</strong>
                      <span>{{ item.courseName }}</span>
                    </div>
                  </ng-template>

                </p-dropdown>

              </div>

              <div class="ecb-web-long-course-search-field">

                <label for="homeLongCourseKeyword">Keyword</label>

                <div class="ecb-web-long-course-keyword">

                  <i class="bi bi-search"></i>

                  <input id="homeLongCourseKeyword" type="search" [(ngModel)]="longCourseKeyword"
                    placeholder="Search qualifications" (keyup.enter)="searchLongCourses()">

                </div>

              </div>

              <button type="button" class="btn ecb-web-long-course-search-button" (click)="searchLongCourses()">

                <i class="bi bi-search"></i>
                Search

              </button>

            </div>
            <!-- End Qualification Search -->


            <!-- Start Long Course 2 x 2 Grid -->
            <div class="row   ecb-web-short-option-grid">

              <div class="col-6" *ngFor="let tag of tags">

                <article class="ecb-web-short-option-card  ">

                  <!-- Icon -->
                  <div class="ecb-web-short-option-icon" [ngClass]="dashboardIconClasses[tag.dashboard || '']">

                    <i [ngClass]="dashboardIcons[tag.dashboard || '']"></i>

                  </div>

                  <!-- Dynamic Tag Title -->
                  <h4 class="ecb-web-long-option-title">
                    {{ tag.tagName }}
                  </h4>

                  <!-- Dynamic Tag Description -->
                  <p>
                    {{ getPlainDescription(tag.description) }}
                  </p>

                  <!-- View Courses -->
                  <a [routerLink]="['/course-qualifications']" [queryParams]="{
                    view: 'list',
                    categoryName: tag.slug,
                    state_code: selectedQualificationStateCode?.toLowerCase()
                  }" class="btn ecb-web-short-option-button ecb-web-long-option-button">

                    <span>View Courses</span>

                    <i class="bi bi-arrow-right"></i>

                  </a>

                </article>

              </div>

            </div>
            <!-- End Long Course Grid -->

          </article>

        </div>
        <!-- End Long Courses Card -->


        <!-- =====================================================
           Start Short Courses Card
      ====================================================== -->
        <div class="col-12 col-xl-6">

          <article class="ecb-web-training-category-card ecb-web-short-course-card h-100">

            <!-- Floating Icon -->
            <div class="ecb-web-training-category-icon ecb-web-short-course-icon">
              <i class="bi bi-journal-text"></i>
            </div>

            <!-- Start Short Courses Heading -->
            <div class="ecb-web-training-category-header text-center">

              <!-- Dynamic Title -->
              <h3>
                {{ homeCourseContent['SHORT_COURSES']?.title ?? 'Short Courses' }}
              </h3>

              <!-- Dynamic Subtitle -->
              <h5>
                {{ homeCourseContent['SHORT_COURSES']?.subTitle ?? 'Book Training Today' }}
              </h5>

              <!-- Dynamic Description -->
              <p class="ecb-web-home-dynamic-description">
                {{ homeCourseContent['SHORT_COURSES']?.description ?? 'Get job-ready with short courses and assessments.     Fast, flexible and industry focused.' }}
              </p>

            </div>
            <!-- End Short Courses Heading -->
            <!-- Start State Selection -->
              <div class="ecb-states-select-wrapper">

                <label class="ecb-states-select-label">Location</label>

           


              <p-selectButton
                [options]="statesList"
                [ngModel]="selectedShortCourseStateCode"
                (ngModelChange)="onShortCourseStateChange($event)"
                optionLabel="siteName"
                optionValue="code"
                [multiple]="false"
                [allowEmpty]="false"
                styleClass="ecb-states-select-button">
              </p-selectButton>
              </div>
              <!-- End State Selection -->

            <!-- Start Short Course Search -->
            <div class="ecb-web-long-course-search">
             
              <div class="ecb-web-long-course-search-field">

                <label>All Courses</label>

                <p-dropdown [options]="shortCourseOptions" [(ngModel)]="selectedCourseFilter" optionValue="courseTitle"
                  [filter]="true" filterBy="courseCode,courseTitle,qualificationType"
                  [showClear]="!!selectedCourseFilter" [virtualScroll]="true" [virtualScrollItemSize]="42"
                  appendTo="body" placeholder="Select a course">

                  <ng-template pTemplate="selectedItem" let-item>

                    <span *ngIf="item">
                      {{ item.courseCode }} - {{ item.courseTitle }}
                    </span>

                  </ng-template>

                  <ng-template pTemplate="item" let-item>

                    <div class="ecb-web-course-option">

                      <strong>{{ item.courseCode }}</strong>

                      <span>{{ item.courseTitle }}</span>

                    </div>

                  </ng-template>

                </p-dropdown>

              </div>

              <div class="ecb-web-long-course-search-field">

                <label for="homeShortCourseKeyword">Keyword</label>

                <div class="ecb-web-long-course-keyword">

                  <i class="bi bi-search"></i>

                  <input id="homeShortCourseKeyword" type="search" [(ngModel)]="shortCourseKeyword"
                    placeholder="Search Short Course" (keyup.enter)="searchShortCourses()">

                </div>

              </div>

              <button type="button" class="btn ecb-web-long-course-search-button" (click)="searchShortCourses()">

                <i class="bi bi-search"></i>
                Search

              </button>

            </div>
            <!-- End Short Course Search -->

            <!-- Short Course Categories -->
            
<!-- New Short Course Category Layout -->
<div class="new-ecb-short-category-layout">

  <!-- Short Course 2 x 2 Grid -->
  <div class="new-ecb-short-option-grid">

    <!-- =====================================
         ALL COURSES
    ====================================== -->
    <div class="new-ecb-short-option-column">

      <article class="new-ecb-short-option-card">

        <div class="new-ecb-short-option-icon new-ecb-short-uoc-icon">
          <i class="bi bi-clipboard2-check"></i>
        </div>

        <h4>
          {{ homeCourseContent['ALL_COURSES']?.title ?? 'All Courses' }}
        </h4>

        <p class="new-ecb-short-description">
          {{ homeCourseContent['ALL_COURSES']?.description ?? '-' }}
        </p>

        <a
          [routerLink]="['/course-short']"
          [queryParams]="{
            type: 'all_courses',
            state_code: selectedShortCourseStateCode?.toLowerCase()
          }"
          class="new-ecb-short-option-button new-ecb-short-uoc-button">

          <span>View Courses</span>
          <i class="bi bi-arrow-right"></i>

        </a>

      </article>

    </div>
    <!-- End All Courses -->


    <!-- =====================================
         VOC
    ====================================== -->
    <div class="new-ecb-short-option-column">

      <article class="new-ecb-short-option-card">

        <div class="new-ecb-short-option-icon new-ecb-short-voc-icon">
          <i class="bi bi-patch-check"></i>
        </div>

        <h4>
          {{ homeCourseContent['VOC']?.title ?? 'VOC' }}
        </h4>

        <p class="new-ecb-short-description">
          {{ homeCourseContent['VOC']?.description ??
             'Verification of Competency assessments.' }}
        </p>

        <a
          [routerLink]="['/course-voc']"
          class="new-ecb-short-option-button new-ecb-short-voc-button">

          <span>View Assessments</span>
          <i class="bi bi-arrow-right"></i>

        </a>

      </article>

    </div>
    <!-- End VOC -->


    <!-- =====================================
         SKILL SETS
    ====================================== -->
    <div class="new-ecb-short-option-column">

      <article class="new-ecb-short-option-card">

        <div class="new-ecb-short-option-icon new-ecb-short-skill-icon">
          <i class="bi bi-journal-bookmark-fill"></i>
        </div>

        <h4>
          {{ homeCourseContent['SKILL_SETS']?.title ?? 'Skill Sets' }}
        </h4>

        <p class="new-ecb-short-description">
          {{ homeCourseContent['SKILL_SETS']?.description ?? '-' }}
        </p>

        <a
          [routerLink]="['/course-short']"
          [queryParams]="{
            type: 'ss',
            state_code: selectedShortCourseStateCode?.toLowerCase()
          }"
          class="new-ecb-short-option-button new-ecb-short-skill-button">

          <span>View Courses</span>
          <i class="bi bi-arrow-right"></i>

        </a>

      </article>

    </div>
    <!-- End Skill Sets -->


    <!-- =====================================
         HIGH RISK COURSES
    ====================================== -->
    <div class="new-ecb-short-option-column">

      <article class="new-ecb-short-option-card">

        <div class="new-ecb-short-option-icon new-ecb-short-high-risk-icon">
          <i class="bi bi-cone-striped"></i>
        </div>

        <h4>
          {{ homeCourseContent['HIGH_RISK']?.title ?? 'High Risk Courses' }}
        </h4>

        <p class="new-ecb-short-description">
          {{ homeCourseContent['HIGH_RISK']?.description ?? '' }}
        </p>

        <a
          [routerLink]="['/course-short']"
          [queryParams]="{
            type: 'hrc',
            state_code: selectedShortCourseStateCode?.toLowerCase()
          }"
          class="new-ecb-short-option-button new-ecb-short-high-risk-button">

          <span>View Courses</span>
          <i class="bi bi-arrow-right"></i>

        </a>

      </article>

    </div>
    <!-- End High Risk Courses -->

  </div>
  <!-- End Short Course Grid -->


  <!-- =====================================
       HSR CENTRE CIRCLE
  ====================================== -->
  <!-- HSR Centre Circle -->
<div class="new-ecb-hsr-centre-wrapper">

   <a
  [routerLink]="['/course-hsr']"
  [queryParams]="{
    type: 'hsr',
    state_code: selectedShortCourseStateCode?.toLowerCase()
  }"
  class="new-ecb-hsr-centre-card">

    <!-- HSR Icon -->
    <div class="new-ecb-hsr-centre-icon">
      <i class="bi bi-shield-check"></i>
    </div>

    <!-- Dynamic Title -->
    <h4>
      {{ homeCourseContent['HSR']?.title || 'HSR' }}
    </h4>

    <!-- Dynamic Subtitle -->
    <span>
      {{ homeCourseContent['HSR']?.subTitle || 'Training' }}
    </span>

    <!-- View Courses -->
    <div class="new-ecb-hsr-centre-action">
      View Courses
      <i class="bi bi-arrow-right"></i>
    </div>

  </a>

</div>
  <!-- End HSR Circle -->

</div>
<!-- End New Short Course Category Layout -->

            </article>

          </div>
          <!-- End Short Courses Card -->

      </div>

    </div>

  </section>
  <!-- End Training Options Section -->



  <!-- Start Course Calendar Section -->
  <section class="ecb-web-course-calendar-section">

    <div class="container">

      <div class="ecb-web-course-calendar-card">

        <!-- Section Heading -->
        <div class="ecb-web-course-calendar-content">

          <div class="ecb-web-course-calendar-icon">
            <i class="bi bi-calendar-week"></i>
          </div>

          <h2>
            Find Your Next Training Date
          </h2>

          <p>
            Explore upcoming training dates and available course sessions.
            Use our course calendar to find a suitable date and start your booking.
          </p>

        </div>

        <!-- Calendar Button -->
        <div class="ecb-web-course-calendar-button-wrapper">

          <a href="/course-calendar" class="btn ecb-web-course-calendar-button">

            <span>View Course Calendar</span>

            <i class="bi bi-calendar3"></i>

          </a>

        </div>

      </div>

    </div>

  </section>
  <!-- End Course Calendar Section -->
 

  <!-- Start Why Choose Section -->
  <section class="ecb-web-why-choose-section">
    <div class="container">

      <!-- Start Section Heading Section -->
      <div class="ecb-web-section-heading">
        <h2>
          Why Choose
          <span>ECB Training?</span>
        </h2>
      </div>
      <!-- End Section Heading Section -->

      <div class="row g-3 row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-6">

        <div class="col" *ngFor="let feature of features; trackBy: trackById">
          <article class="ecb-web-feature-card">
            <i [class]="feature.icon"></i>

            <div>
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.description }}</p>
            </div>
          </article>
        </div>

      </div>
    </div>
  </section>
  <!-- End Why Choose Section -->

 

  <!-- Start Industry Section -->
  <section class="ecb-web-industry-section">
    <div class="container">

      <!-- Start Industry Heading Section -->
      <div class="ecb-web-section-heading">
        <h2>
          Training for Every
          <span>Industry</span>
        </h2>
      </div>
      <!-- End Industry Heading Section -->

      <!-- Start Industry List Section -->
      <div class="ecb-web-industry-list">

        <article class="ecb-web-industry-card" *ngFor="let industry of industries; trackBy: trackById"
          [ngClass]="industry.className">
          <i [class]="industry.icon"></i>
          <h3>{{ industry.name }}</h3>
        </article>

      </div>
      <!-- End Industry List Section -->

    </div>
  </section>
  <!-- End Industry Section -->

  <!-- Start Statistics Section -->
  <section class="ecb-web-statistics-section">
    <div class="container">
      <div class="row g-0 row-cols-1 row-cols-sm-2 row-cols-lg-4">

        <div class="col" *ngFor="let statistic of statistics; trackBy: trackById">
          <article class="ecb-web-statistic-card">
            <div class="ecb-web-statistic-icon">
              <i [class]="statistic.icon"></i>
            </div>

            <div>
              <h3>{{ statistic.value }}</h3>
              <p>{{ statistic.label }}</p>
            </div>
          </article>
        </div>

      </div>
    </div>
  </section>
  <!-- End Statistics Section -->

  <!-- Start Training Journey Section -->
  <section class="ecb-web-journey-section">
    <div class="container">

      <div class="ecb-web-section-heading">
        <h2>
          Your Journey with
          <span>ECB Training</span>
        </h2>
      </div>

      <div class="row g-4 row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-6">

        <div class="col" *ngFor="
            let journeyStep of journeySteps;
            let lastItem = last;
            trackBy: trackById
          ">
          <article class="ecb-web-journey-card">
            <div class="ecb-web-journey-icon">
              <i [class]="journeyStep.icon"></i>
            </div>

            <span class="ecb-web-journey-arrow" *ngIf="!lastItem">
              <i class="bi bi-arrow-right"></i>
            </span>

            <small>{{ journeyStep.stepNumber }}</small>
            <h3>{{ journeyStep.title }}</h3>
            <p>{{ journeyStep.description }}</p>
          </article>
        </div>

      </div>
    </div>
  </section>
  <!-- End Training Journey Section -->

  

  <!-- Start Workforce Banner Section -->
  <!-- Start Workforce Banner Section -->
<section id="workforce" class="ecb-web-workforce-section">

  <div class="container-fluid p-0">

    <div class="row g-0 align-items-stretch">

      <!-- Workforce Image -->
      <div class="col-12 col-lg-4">
        <div class="ecb-web-workforce-image-wrapper">
          <img
            src="assets/images/workforce-training.webp"
            alt="Workforce Training"
            class="ecb-web-workforce-image">
        </div>
      </div>

      <!-- Content + Buttons -->
      <div class="col-12 col-lg-8">

        <div class="ecb-web-workforce-right-wrapper">

          <!-- Content -->
          <div class="ecb-web-workforce-content">

            <h2>
              Need Training for
              <span>Your Workforce?</span>
            </h2>

            <p>
              We deliver customised, cost-effective training solutions
              that meet your business needs.
            </p>

            <div class="ecb-web-workforce-features">

              <div class="ecb-web-workforce-feature-item">
                <i class="bi bi-house-door"></i>
                <div>
                  <strong>Onsite Training</strong>
                  <small>We come to you</small>
                </div>
              </div>

              <div class="ecb-web-workforce-feature-item">
                <i class="bi bi-people"></i>
                <div>
                  <strong>Group Discounts</strong>
                  <small>Save more</small>
                </div>
              </div>

              <div class="ecb-web-workforce-feature-item">
                <i class="bi bi-calendar-check"></i>
                <div>
                  <strong>Custom Programs</strong>
                  <small>Tailored for your team</small>
                </div>
              </div>

            </div>

          </div>

          <!-- Buttons -->
          <div class="ecb-web-workforce-button-wrapper">

            <a routerLink="/contact-us"
               class="btn ecb-web-workforce-primary-button">
              Request a Proposal
            </a>

            <a routerLink="/contact-us"
               class="btn ecb-web-workforce-outline-button">
              Contact Us
            </a>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>
  <!-- End Workforce Banner Section -->

 <!-- Start Information Card Section -->
  <section id="training-locations" class="ecb-web-information-section">
    <div class="container">
      <div class="row g-4">

        <!-- Start Partner Card Section -->
        <div class="col-12 col-md-6 col-xl-3">
          <article class="ecb-web-partner-card">

            <!-- Start Partner Card Heading Section -->
            <h3 class="ecb-web-partner-card-title">
              Industries We Support
            </h3>
            <!-- End Partner Card Heading Section -->

            <!-- Start Partner Logo Grid Section -->
            <div class="ecb-web-partner-logo-grid">

              <div class="ecb-web-partner-logo-item" *ngFor="let partner of partnerLogos; trackBy: trackById">
                <img [src]="partner.image" [alt]="partner.name" [title]="partner.name"
                  class="ecb-web-partner-logo-image">
              </div>

            </div>
            <!-- End Partner Logo Grid Section -->

            <!-- Start Partner Button Section -->
            <div class="ecb-web-partner-button-wrapper">
              <!-- <button type="button" class="btn ecb-web-partner-view-button">
                View More Partners
              </button> -->
            </div>
            <!-- End Partner Button Section -->

          </article>
        </div>
        <!-- End Partner Card Section -->

        <!-- Start Testimonial Card Section -->
        <div class="col-12 col-md-6 col-xl-3">
          <article class="ecb-web-information-card">
            <h3>What Our Students Say</h3>

            <div class="ecb-web-testimonial-stars">
              <i class="bi bi-star-fill"></i>
              <i class="bi bi-star-fill"></i>
              <i class="bi bi-star-fill"></i>
              <i class="bi bi-star-fill"></i>
              <i class="bi bi-star-fill"></i>
            </div>

            <blockquote>
              “ECB Training delivered high quality training to me and my workmate on Scissor Lift and EWP along with
              WSAH in a quick and understandable method.​

              Learnt heaps of new stuff and reinforced a lot of existing stuff to allow me to work safer.​”
            </blockquote>

            <strong>– Beau Masson​
            </strong>
            <small>Base Industries​</small>

            <div class="ecb-web-google-review-box">
              <span class="ecb-web-google-letter">G</span>

              <div>
                <strong>4.9</strong>
                <small>on Google with numerous customer reviews. </small>
              </div>
            </div>
          </article>
        </div>
        <!-- End Testimonial Card Section -->

        <!-- Start Location Card Section -->
        <!-- Start Training Location Card Section -->
        <div class="col-12 col-md-6 col-xl-3">
          <article class="ecb-web-location-card">

            <!-- Start Training Location Heading Section -->
            <h3 class="ecb-web-location-card-title">
              Training Locations
            </h3>
            <!-- End Training Location Heading Section -->

            <!-- Start Training Location Body Section -->
            <div class="ecb-web-location-card-body">

              <!-- Start Australia Map Section -->
              <div class="ecb-web-location-map-wrapper">
                <img src="assets/images/australia-map.webp" alt="ECB Training Locations in Australia"
                  class="ecb-web-location-map-image">
              </div>
              <!-- End Australia Map Section -->

              <!-- Start Location List Section -->
              <div class="ecb-web-location-list">

                <div class="ecb-web-location-list-item">
                  <strong>Victoria</strong>
                  <p  >598 Kororoit Creek Road,<br> Altona North, VIC  3025.</p>
                  
                </div>

                <div class="ecb-web-location-list-item">
                  <strong>Northern Territory</strong>
                  <p >44 McMinn Street, Darwin, NT  0800.</p>
                </div>
 

              </div>
              <!-- End Location List Section -->

            </div>
            <!-- End Training Location Body Section -->

            <!-- Start Training Location Button Section -->
            <div class="ecb-web-location-button-wrapper">
             <!--  <button type="button" class="btn ecb-web-location-view-button">
                View All Locations
              </button> -->
            </div>
            <!-- End Training Location Button Section -->

          </article>
        </div>
        <!-- End Training Location Card Section -->
        <!-- End Location Card Section -->

        <!-- Start Upcoming Course Card Section -->
        <div class="col-12 col-md-6 col-xl-3">
          <article class="ecb-web-information-card">
            <h3>Upcoming Courses</h3>

            <div class="ecb-web-upcoming-list">

              <ng-container *ngIf="upcomingCourses?.length > 0; else noUpcomingCourses">

                <div class="ecb-web-upcoming-item" *ngFor="
        let upcomingCourse of upcomingCourses;
        trackBy: trackById
      ">

                  <div class="ecb-web-upcoming-content">
                    <i class="bi bi-circle-fill"></i>

                    <div>
                      <strong>{{ upcomingCourse.title }}</strong>
                      <small>{{ upcomingCourse.location }}</small>
                    </div>
                  </div>

                  <div class="ecb-web-upcoming-date">
                    <small>{{ upcomingCourse.month }}</small>
                    <strong>{{ upcomingCourse.day }}</strong>
                  </div>

                </div>

              </ng-container>

              <ng-template #noUpcomingCourses>
                <div class="ecb-web-upcoming-empty">
                  <i class="bi bi-calendar-event"></i>
                  <strong>Upcoming courses coming soon</strong>
                  <small>New course dates will be available shortly.</small>
                </div>
              </ng-template>

            </div>

            <button (click)="viewAllCourseDates()" type="button" class="btn ecb-web-information-button">


              View All Dates

            </button>
          </article>
        </div>
        <!-- End Upcoming Course Card Section -->

      </div>
    </div>
  </section>
  <!-- End Information Card Section -->

</div>
<!-- End Home Page Section -->


<div class="ecb-admin-login-modal-backdrop" *ngIf="showAdminLoginModal">

  <div class="ecb-admin-login-modal">

    <div class="ecb-admin-login-modal-header">

      <h2>
        Admin Login
      </h2>

      <p>
        Use your ECB Training admin account credentials.
      </p>

    </div>


    <div class="ecb-admin-login-field">

      <label>
        Email Address
      </label>

      <input type="email" class="form-control" [(ngModel)]="loginEmail" name="loginEmail"
        placeholder="Enter email address">

    </div>


    <div class="ecb-admin-login-field">

      <label>
        Password
      </label>

      <input type="password" class="form-control" [(ngModel)]="loginPassword" name="loginPassword"
        placeholder="Enter password">

    </div>


    <button type="button" class="btn ecb-admin-login-button" (click)="adminLogin()">

      <i class="bi bi-box-arrow-in-right"></i>

      Login

    </button>

  </div>

</div>